import React from "react";
import { Platform, Pressable, StyleSheet, View, type ViewStyle } from "react-native";

import InteractiveLearningFormDataContainer from "../../../../../containers/customCoursework/InteractiveLearningForm/InteractiveLearningFormDataContainer";
import type { ActivityDataInput } from "../../../../../components/customCoursework/ActivityForms/InteractiveLearningForm/InteractiveLearningFormCore";
import { colors } from "../../../../../styles/design-system";

interface ModernizerIleCreationSheetProps {
  open: boolean;
  initialValues: ActivityDataInput;
  isSubmitting: boolean;
  onSave: (data: ActivityDataInput) => void;
  onClose: () => void;
}

function ModernizerIleCreationSheet({
  open,
  initialValues,
  isSubmitting,
  onSave,
  onClose,
}: ModernizerIleCreationSheetProps) {
  if (!open) {
    return null;
  }

  return (
    <View style={styles.overlay} pointerEvents="box-none">
      <Pressable
        accessibilityRole="button"
        accessibilityLabel="Close ILE creator"
        style={styles.backdrop}
        onPress={onClose}
      />
      <View style={styles.sheet}>
        <View style={styles.formBody}>
          <InteractiveLearningFormDataContainer
            activityData={initialValues}
            onSave={onSave}
            onCancel={onClose}
            isSubmitting={isSubmitting}
            imageGenerationSupportFlag={false}
          />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 20,
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  backdrop: {
    flex: 1,
    backgroundColor: "rgba(15, 23, 42, 0.24)",
  },
  sheet: {
    width: 720,
    maxWidth: "100%",
    height: "100%",
    backgroundColor: colors.white,
    borderLeftWidth: 1,
    borderLeftColor: colors.grey[200],
    ...(Platform.OS === "web"
      ? ({
          boxShadow: "0 24px 48px rgba(15, 23, 42, 0.22)",
          overflow: "hidden",
        } as ViewStyle)
      : {}),
  },
  formBody: {
    flex: 1,
    minHeight: 0,
  },
});

export default ModernizerIleCreationSheet;
